import { Button } from "@/components/shared/buttons/Button";
import { useState } from "react";
import { NewClauseDialog } from "./dialogs/clauses/NewClauseDialog";

/**
 * Button to add a new clause
 */
export const AddNewClauseButton = () => {
    const [open, setOpen] = useState(false);

    return (
        <>
            <Button
                type="button"
                variant="contained"
                color="secondary"
                disableElevation
                sx={{ borderRadius: 22 }}
                onClick={() => setOpen(true)}
            >
                Add New Clause
            </Button>
            <NewClauseDialog open={open} onClose={() => setOpen(false)} />
        </>
    );
};
